import {Constants} from '../constants/constants';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from "moment";

@Pipe({
  name: 'DateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, Constants.DATE_FMT);
  }
}

@Pipe({ name: 'UTCDate' })
export class UTCDatePipe implements PipeTransform {
    constructor() { }
    transform(value) {
        if (value) {
            return moment.utc(value).format('YYYY MMMM DD');
        } else {
            return '';
        }
    }
}
